import moment from "moment";

export const groupProductosByMateriaPrima = function (detalles) {
    if (!detalles || !Array.isArray(detalles)) {
        return [];
    }

    var grouped = detalles.reduce(function (acc, item) {
        if (!item || !item.materia_prima || !item.materia_prima.id) {
            return acc;
        }

        var key = item.materia_prima.id;

        if (!acc[key]) {
            acc[key] = {
                materia_prima: item.materia_prima,
                kilos_humedos: 0,
                kilos_secos_laboratorio: 0,
                // kilos_secos_compra: 0,
                ingresos_ids: [],
                fechas: [],
            };
        }

        acc[key].kilos_humedos += Number(item.kilos_humedos) || 0;
        acc[key].kilos_secos_laboratorio +=
            Number(item.kilos_secos_laboratorio) || 0;
        // acc[key].kilos_secos_compra += Number(item.kilos_secos_compra) || 0;

        if (item.id_ingreso) {
            acc[key].ingresos_ids.push(item.id_ingreso);
        }

        if (item.fecha_entrada) {
            acc[key].fechas.push(new Date(item.fecha_entrada));
        }

        return acc;
    }, {});

    return Object.keys(grouped).map(function (key) {
        var producto = grouped[key];

        if (!producto.kilos_humedos) {
            producto.kilos_humedos = null;
        }
        if (!producto.kilos_secos_laboratorio) {
            producto.kilos_secos_laboratorio = null;
        }
        // if (!producto.kilos_secos_compra) {
        //     producto.kilos_secos_compra = null;
        // }

        // concatenar los ingresos_ids en un string separado por comas
        producto.ingresos_ids_concat = producto.ingresos_ids.join(", ");

        // calcular rango de fechas
        if (producto.fechas.length > 0) {
            const minFecha = new Date(Math.min(...producto.fechas));
            const maxFecha = new Date(Math.max(...producto.fechas));

            // formatear con moment para que quede DD/MM/YYYY
            const format = (date) => moment(date).format("DD/MM/YYYY");

            if (minFecha.getTime() === maxFecha.getTime()) {
                producto.rango_fechas = format(minFecha);
            } else {
                producto.rango_fechas = `${format(minFecha)} - ${format(maxFecha)}`;
            }
        } else {
            producto.rango_fechas = null;
        }

        return producto;
    });
};

export const mergePesajesMateriaPrima = (grouped, trasladoDetalle) => {
    const pesajes =
        trasladoDetalle && trasladoDetalle.pesajes
            ? trasladoDetalle.pesajes
            : [];

    if (!pesajes || pesajes.length === 0) return grouped;

    return grouped.map((item) => {
        const pesaje = pesajes.find(
            (p) => p.materia_prima_id === item.materia_prima.id,
        );

        return {
            ...item,
            pesaje,
            yaPesado: !!pesaje,
        };
    });
};

export const sortMateriaPrima = (items) => {
    return [...items].sort((a, b) => {
        if (a.yaPesado && b.yaPesado) {
            return a.pesaje.orden - b.pesaje.orden;
        } else if (a.yaPesado) {
            return -1;
        } else if (b.yaPesado) {
            return 1;
        } else {
            return 0;
        }
    });
};

export const buildResumenMateriaPrima = (
    detalles,
    trasladoDetalle
) => {
    const grouped = groupProductosByMateriaPrima(detalles);

    const merged = mergePesajesMateriaPrima(grouped, trasladoDetalle);

    return sortMateriaPrima(merged);
};
